import CommonOTSheet from "../../components/common/OTSheet/CommonOTSheet";


function PendingSheet() {
  
  return (
    <div  className="bg-white">
      <CommonOTSheet view_by_status={2} sheet_name="Pending" />
    </div>
  );
}

export default PendingSheet;
